var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29446 17.8811C8.77027 18.6456 8.20887 19.3839 7.61228 20.0933C3.34613 19.972 1.72754 17.203 1.72754 17.203C1.78757 13.2796 2.73835 9.42119 4.50805 5.9191C6.06316 4.70252 7.95804 3.99952 9.93033 3.90742L10.5084 5.24276C11.3341 5.12866 12.1664 5.0688 12.9999 5.06356C13.8371 5.06638 14.6733 5.12431 15.5029 5.23698L16.081 3.90164C18.0552 3.99872 19.9503 4.70786 21.5033 5.93066C23.2673 9.4302 24.214 13.2844 24.2722 17.203C24.2722 17.203 22.6536 19.972 18.3875 20.0933C17.7995 19.3876 17.2477 18.6525 16.7342 17.8909M20.4685 16.2145C18.2487 17.3389 16.1012 18.4632 12.9999 18.4632C9.89854 18.4632 7.75102 17.3389 5.53123 16.2145M11.3796 13.2895C11.3796 14.359 10.5125 15.226 9.44302 15.226C8.37351 15.226 7.50649 14.359 7.50649 13.2895C7.50649 12.22 8.37351 11.3529 9.44302 11.3529C10.5125 11.3529 11.3796 12.22 11.3796 13.2895ZM18.4933 13.2895C18.4933 14.359 17.6263 15.226 16.5567 15.226C15.4872 15.226 14.6202 14.359 14.6202 13.2895C14.6202 12.22 15.4872 11.3529 16.5567 11.3529C17.6263 11.3529 18.4933 12.22 18.4933 13.2895Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.0cbbe1b7e6140ae45ea827c698e924a5.svg";
export { ForwardRef as ReactComponent };